module.exports = __webpack_public_path__ + "static/img/web_google_welcome.d117bbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/imageSaver/web_google_welcome.png
// module id = 5/Ua
// module chunks = 2